import React from 'react';
import { Link } from 'react-router'
import WorksTypeBig from './WorksTypeBig'
import WorksTypeSmall from './WorksTypeSmall'
import $ from 'jquery'

let thumbnail = require('../images/dummy.png')
let config = require('config');

class Top extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isTypeBig:true,
      isMobile:false
    }
    this.changeTypeBig = this.changeTypeBig.bind(this);
    this.changeTypeSmall = this.changeTypeSmall.bind(this);
  }

  componentDidMount() {
    document.title = config.default.SITE_NAME
    const { actions, data } = this.props;
    if(data.member == null) {
      actions.getMember()
    }
    actions.getWorks()

    $(window).on("resize", this.resize.bind(this))
    this.resize()

    this.changeMember = this.changeMember.bind(this)
  }

  changeMember(e) {
    const { actions, data } = this.props;
    var id = e.target.value
    if (id == "all") {
      actions.getWorks()
    } else {
      actions.getWorks(id)
    }
  }

  componentWillUnmount() {
    $(window).off("resize")
  }

  changeTypeBig() {
    $("a.type_small").removeClass("current")
    $("a.type_big").addClass("current")
    this.setState({
      isTypeBig:true
    })
    return
  }

  changeTypeSmall() {
    $("a.type_big").removeClass("current")
    $("a.type_small").addClass("current")
    this.setState({
      isTypeBig:false
    })
    return
  }

  render() {
    const { actions, data } = this.props;
    var self = this
    var works  = data.works;
    var member = data.member;

    return (
      <div id="top" className="main">
        <div className="top_inner">
          <div className="top__header">
            <div className="header__select">
              <div className="select__title">FILTER</div>
              <select id="select_member" name="select_member" className="select" onChange={this.changeMember}>
                <option value="all">ALL MEMBERS</option>
                { member ?
                    member.contents.map(function(m, i) {
                      return (
                        <option key={i} value={m.id}>{m.name_en}</option>
                      )
                    })
                  :null
                }
              </select>
            </div>
            { !this.state.isMobile ?
                <div className="header__type">
                  <div className="type_button__big type_button">
                    <a className="type_big current" onClick={this.changeTypeBig}>
                      <span></span>
                    </a>
                  </div>
                  <div className="type_button__small type_button">
                    <a className="type_small" onClick={this.changeTypeSmall}>
                      <span className="rt"></span>
                      <span className="lt"></span>
                      <span className="rb"></span>
                      <span className="lb"></span>
                    </a>
                  </div>
                </div>
              :null
            }
          </div>
          <div className="top__content">
            { this.state.isMobile ?
                <WorksTypeSmall works={works} />
              :
                <div>
                  { this.state.isTypeBig ?
                    <WorksTypeBig works={works} />
                    :
                    <WorksTypeSmall works={works} />
                  }
                </div>
            }
          </div>
        </div>
      </div>
    );
  }

  resize() {
    var w = $(window).width()
    var h = $(window).height()
    if (w < config.default.MEDIA_ALL_MOBILE) {
      if (!this.state.isMobile) {
        this.setState({ isMobile:true });
      }
    } else {
      if (this.state.isMobile) {
        this.setState({ isMobile:false });
      }
    }
  }
}

Top.displayName = 'Top';
Top.propTypes = {};
Top.defaultProps = {};

export default Top;



// WEBPACK FOOTER //
// ./components/Top.js